import type { ImportStepProps, ImportStepMap } from "./import-types";
import {
  FooterContainer,
  FooterNextButton,
  FooterSkipButton,
  StepTitle,
  StyledStepTitleWrapper,
  WizardContentWrapper,
} from "@/components/onboarding/components/welcome-wizard/onboarding-steps.styles";
import { DropTargetStep } from "./drop-target-step";
import { StepContentWithTabs } from "./tabs";
import { getFilteredNotesApps } from "./import-steps.config";
import { MDSTextWeight, MDSTextVariant, MDSText, MDSIconButton, MDSIconKind } from "@/mds";

const ObsidianStep: React.FC<ImportStepProps> = ({ onSkip, handleTabSelect, onClose, context }) => (
  <WizardContentWrapper>
    <StyledStepTitleWrapper>
      <StepTitle>Import Notes</StepTitle>
      {context.placement === "profile-menu" && (
        <MDSIconButton iconKind={MDSIconKind.Exit} onClick={onClose} />
      )}
    </StyledStepTitleWrapper>
    <StepContentWithTabs
      selectedAppId={context?.selectedAppId || null}
      onAppSelect={handleTabSelect}
      tabConfig={{ tabs: getFilteredNotesApps() }}
    >
      <MDSText variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Regular}>
        Bring in your Obsidian notes so you can find them with Mem Search, Chat, and Heads Up
      </MDSText>
      <DropTargetStep
        onDrop={() => {
          onClose?.();
        }}
      />
    </StepContentWithTabs>
    {context.placement === "onboarding" && (
      <FooterContainer align="space-between">
        <FooterSkipButton onClick={onSkip}>Skip for now</FooterSkipButton>
        <FooterNextButton onClick={() => onClose?.()}>Next step</FooterNextButton>
      </FooterContainer>
    )}
  </WizardContentWrapper>
);

export const ObsidianStepsMap: ImportStepMap = {
  "obsidian-1": {
    id: "obsidian-1",
    render: props => <ObsidianStep {...props} />,
  },
};
